// extracted by mini-css-extract-plugin
module.exports = {"IntroText":"IntroText_IntroText__ZuKRn","inner":"IntroText_inner__eUAZ_","title":"IntroText_title__cOxpu","description":"IntroText_description__e_hLl"};